export const SHORT_URL_EVENTS = {
  FLOW_ENTERED: "short_url_flow_entered",
  FLOW_COMPLETED: "short_url_flow_completed",
  FLOW_ABANDONED: "short_url_flow_abandoned",
  ACCESS_CODE_RESOLVED: "short_url_access_code_resolved",
  PAGE_LOADED: "short_url_page_loaded",
  STATE_RENDERED: "short_url_state_rendered",
  MEET_REDIRECT_TRIGGERED: "short_url_meet_redirect_triggered",
  MEET_REDIRECT_FAILED: "short_url_meet_redirect_failed",
} as const;

export const BOOKING_EVENTS = {
  BOOKING_STARTED: "g_session_booking_started",
  TIME_SLOTS_VIEWED: "g_session_time_slots_viewed",
  TIME_SLOT_SELECTED: "g_session_time_slot_selected",
  TIME_SLOT_CHANGED: "g_session_time_slot_changed",
  MESSAGE_COACH_VIEWED: "g_session_message_coach_viewed",
  CONFIRMATION_VIEWED: "g_session_confirmation_viewed",
  CONFIRMATION_FIELD_EDITED: "g_session_confirmation_field_edited",
  BOOKING_SUBMITTED: "g_session_booking_submitted",
  BOOKING_FAILED: "g_session_booking_failed",
  BOOKING_COMPLETED: "g_session_booking_completed",
  BOOKING_EXITED: "g_session_booking_exited",
} as const;

export const RESCHEDULE_EVENTS = {
  RESCHEDULE_STARTED: "g_session_reschedule_started",
  TIME_SLOTS_VIEWED: "g_session_reschedule_time_slots_viewed",
  TIME_SLOT_SELECTED: "g_session_reschedule_time_slot_selected",
  TIME_SLOT_CHANGED: "g_session_reschedule_time_slot_changed",
  CONFIRMATION_VIEWED: "g_session_reschedule_confirmation_viewed",
  CONFIRMATION_FIELD_EDITED: "g_session_reschedule_confirmation_field_edited",
  RESCHEDULE_SUBMITTED: "g_session_reschedule_submitted",
  RESCHEDULE_FAILED: "g_session_reschedule_failed",
  RESCHEDULE_COMPLETED: "g_session_reschedule_completed",
  RESCHEDULE_EXITED: "g_session_reschedule_exited",
} as const;

export const COACH_MATCHING_PAGE_EVENTS = {
  PAGE_VIEWED: "coach_matching_page_viewed",
  APP_DOWNLOAD_TAPPED: "coach_matching_app_download_tapped",
} as const;

export const API_ERROR_TYPES = {
  VALIDATION: "validation_error",
  SERVER: "server_error",
  NETWORK: "network_error",
  UNRECOGNIZED_EMAIL: "unrecognized_email",
  NO_COACH_AVAILABLE: "no_coach_available",
  RATE_LIMITED: "rate_limited",
} as const;

export type ApiErrorType =
  (typeof API_ERROR_TYPES)[keyof typeof API_ERROR_TYPES];
